import moment from 'moment'

export const utils = {
  filters: {
    format: function (value) {
      if (value == null) return '0.00'
      return parseFloat(value).toFixed(2)
    }
  },
  methods: {
    async getAllSettled (promises, returnErrors = false) {
      const rejected = []
      const results = await Promise.allSettled(promises)
      const fulfilled = results.flatMap(result => {
        if (result.status === 'rejected') {
          rejected.push(result)
          return []
        }
        return result.value
      })
      if (rejected.length > 0) console.log('Rejected promises:', rejected)
      if (returnErrors) {
        return { fulfilled, rejected }
      }
      return fulfilled
    },
    getFinalOrderDates(adStartDate, edge_store, is_meat_grid = false) {
      if (this.tenant === 'alliance-retail-group') {
        let lookback = 6
        if (edge_store && is_meat_grid) {
          lookback = 2
        }

        const lookbackWeek = moment(adStartDate).subtract(lookback, 'weeks')
        // Get the next wednesday of the day we looked back to
        let calculatedWednesday = lookbackWeek.clone().day(3) 
        if (calculatedWednesday.isBefore(lookbackWeek)) {
          calculatedWednesday = calculatedWednesday.add(7, 'days')
        }
        const calculatedOrderDate = calculatedWednesday.format('YYYY-MM-DD')
        
        return {
          lastOrderDate: calculatedOrderDate,
          lastShipperOrderDate: null
        }
      } else if (this.tenant === "pricechopper") {
        return {
          lastOrderDate: moment(adStartDate).subtract(5, 'weeks').subtract(2, 'days').format('YYYY-MM-DD'),
          lastShipperOrderDate: moment(adStartDate).subtract(5, 'weeks').subtract(2, 'days').format('YYYY-MM-DD')
        }
      } else {
        return {
          lastOrderDate: moment(adStartDate).subtract(4, 'weeks').format('YYYY-MM-DD'),
          lastShipperOrderDate: moment(adStartDate).subtract(5, 'weeks').format('YYYY-MM-DD')
        }
      }
    },
  }
}
